import React, { useEffect } from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';

import { CONTENT_HISTORY } from '@confluence/named-routes';

import { ContentHistoryHeader } from './ContentHistoryHeader';
import { ContentHistoryPanel } from './ContentHistoryPanel';
import { useNewContentHistory } from './useNewContentHistoryState';

const wrapperStyles = xcss({
	width: '100%',
	height: '100%',
});

const editorAndHeaderWrapperStyles = xcss({
	width: '70%',
	height: '100%',
});

const editorPlaceholderStyles = xcss({
	backgroundColor: 'color.background.accent.blue.subtlest',
	height: 'calc(100% - 56px)', // Subtracting the 56px height of the header
});

const panelStyles = xcss({
	width: '30%',
});

type NewContentHistoryProps = {
	contentId: string;
	spaceKey: string;
};

export const NewContentHistory = ({ contentId, spaceKey }: NewContentHistoryProps) => {
	const [{ wasTransitionedFromEditor }, { hideNewContentHistory }] = useNewContentHistory();

	useEffect(() => {
		if (wasTransitionedFromEditor) {
			// Update to content history url but don't redirect to content history route if we transitioned from editor
			const url = CONTENT_HISTORY.toUrl({
				spaceKey,
				contentId,
			});

			window.history.replaceState({}, '', url);
		}
	}, [wasTransitionedFromEditor, contentId, spaceKey]);

	return (
		<Flex xcss={wrapperStyles}>
			<Flex direction="column" xcss={editorAndHeaderWrapperStyles}>
				<ContentHistoryHeader
					hideNewContentHistory={hideNewContentHistory}
					contentId={contentId}
					spaceKey={spaceKey}
					wasTransitionedFromEditor={wasTransitionedFromEditor}
				/>
				<Flex xcss={editorPlaceholderStyles}> Editor placeholder </Flex>
			</Flex>
			<Box xcss={panelStyles}>
				<ContentHistoryPanel />
			</Box>
		</Flex>
	);
};
